import { AVAILABLE_WORLDS } from '../languages/constants';

type Record = {
    [key: string]: string;
};

type NestedRecords<T> = {
    [key: string]: T;
};

export const aiHelpCenter: Record = {
    de: 'https://help.eduki.com/hc/de/articles/20659689712786-Wie-funktioniert-das-neue-KI-Feature-im-Uploader'
};

export const contactEmails: Record = {
    de: 'hallo@eduki.com',
    es: 'hola@eduki.com',
    fr: 'salut@eduki.com',
    gr: 'hellogreece@eduki.com',
    it: 'ciao@eduki.com'
};

export const helpCenter: Record = {
    de: 'https://help.eduki.com/hc/de',
    es: 'https://help.eduki.com/hc/es',
    fr: 'https://help.eduki.com/hc/fr',
    gr: 'https://help.eduki.com/hc/el',
    it: 'https://help.eduki.com/hc/it',
    ...Object.values(AVAILABLE_WORLDS)
        .filter((world) => !['de', 'es', 'fr', 'gr', 'it'].includes(world))
        .reduce((acc, world) => ({ ...acc, [world]: 'https://help.eduki.com/hc/en-001' }), {})
};

export const HELPCENTER_ARTICLES: NestedRecords<Record> = {
    action: {
        de: 'https://help.eduki.com/hc/de/articles/360020693180-Wie-kann-ich-mein-Material-bearbeiten-z-B-Dateien-austauschen-Angaben-ver%C3%A4ndern-',
        es: 'https://help.eduki.com/hc/es/articles/360020693180--C%C3%B3mo-puedo-editar-mi-material-por-ejemplo-modificar-archivos-o-actualizar-la-descripci%C3%B3n- ',
        fr: 'https://help.eduki.com/hc/fr/articles/360020693180-comment-puis-je-modifier-mon-materiel-par-ex-echanger-un-fichier-actualiser-la-descrip%C3%A4tion'
    },
    earnings: {
        de: 'https://help.eduki.com/hc/de/categories/360003238540-Autor-innen-Honorar',
        es: 'https://help.eduki.com/hc/es/categories/360003238540-Honorarios-de-los-autores-as',
        fr: 'https://help.eduki.com/hc/fr/categories/360003238540-honoraire-de-l-auteur',
        it: 'https://help.eduki.com/hc/it/categories/360003238540-Compenso-per-autori-e-autrici',
        gr: 'https://help.eduki.com/hc/el/categories/360003238540-%CE%91%CE%BC%CE%BF%CE%B9%CE%B2%CE%AE-%CF%83%CF%85%CE%B3%CE%B3%CF%81%CE%B1%CF%86%CE%AD%CF%89%CE%BD'
    },
    upload: {
        de: 'https://help.eduki.com/hc/de/categories/360003252939-Material-hochladen-bearbeiten',
        es: 'https://help.eduki.com/hc/es/categories/360003252939-Subir-y-editar-material',
        fr: 'https://help.eduki.com/hc/fr/categories/360003252939-mettre-en-ligne-editer-ressource'
    },
    qualityReport: {
        de: 'https://help.eduki.com/hc/de/articles/33483419696146-P%C3%A4dagogische-Qualit%C3%A4t-auf-eduki'
    },
    dashboard: {
        de: 'https://help.eduki.com/hc/de/sections/32590112663186-Neues-Autor-innen-Dashboard',
        es: 'https://help.eduki.com/hc/es/sections/32590112663186',
        it: 'https://help.eduki.com/hc/it/sections/32590112663186',
        gr: 'https://help.eduki.com/hc/el/sections/32590112663186',
        nl: 'https://help.eduki.com/hc/en-001/sections/32590112663186-Author-Dashboard'
    }
};

export const saleComplianceArticle: Record = {
    de: 'https://help.eduki.com/hc/de/articles/33451474865682-Einhaltung-der-EU-Rabattpreise',
    es: 'https://help.eduki.com/hc/es/articles/33451474865682-Cumplimiento-de-los-precios-de-venta-en-la-UE',
    fr: 'https://help.eduki.com/hc/fr/articles/33451474865682-Conformit%C3%A9-aux-prix-de-vente-dans-l-UE',
    gr: 'https://help.eduki.com/hc/el/articles/33451474865682-%CE%A4%CE%AE%CF%81%CE%B7%CF%83%CE%B7-%CF%84%CF%89%CE%BD-%CF%84%CE%B9%CE%BC%CF%8E%CE%BD-%CF%80%CF%8E%CE%BB%CE%B7%CF%83%CE%B7%CF%82-%CF%84%CE%B7%CF%82-%CE%95%CE%95',
    it: 'https://help.eduki.com/hc/it/articles/33451474865682-Rispetto-dei-prezzi-di-vendita-nell-UE',
    ...Object.values(AVAILABLE_WORLDS)
        .filter((world) => !['de', 'es', 'fr', 'gr', 'it'].includes(world))
        .reduce(
            (acc, world) => ({
                ...acc,
                [world]: 'https://help.eduki.com/hc/en-001/articles/33451474865682-EU-Sale-Price-Compliance'
            }),
            {}
        )
};

export const contactPhones = {};

export const referralFaqLinks: Record = {
    [AVAILABLE_WORLDS.ES]: 'https://help.eduki.com/hc/es/articles/32506504852498',
    [AVAILABLE_WORLDS.GR]: 'https://help.eduki.com/hc/el/articles/32506914586642'
};

export const referralProgramAutorFAQ: Record = {
    [AVAILABLE_WORLDS.ES]: 'https://help.eduki.com/hc/es/articles/32866810321938',
    [AVAILABLE_WORLDS.GR]: 'https://help.eduki.com/hc/el/articles/32866810321938'
};
